import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SELECTOR_AUTOPLAY_IS_AUTOPLAY_VISIBLE } from 'src/store/reducers/autoplay';
import { SELECTOR_PLAYBACK_FIRST_PLAY, SELECTOR_PLAYBACK_IS_SEEKING } from 'src/store/reducers/playback';

import {
  SELECTOR_UI_IS_USER_ACTIVE,
  SELECTOR_UI_SETTINGS_VISIBLE,
  SELECTOR_UI_SUBTITLE_SETTINGS_VISIBLE,
  SELECTOR_UI_IS_STATS_VISIBLE,
} from 'src/store/reducers/ui';

const useActiveOverlay = () => {
  const isAutoplayVisible = useSelector(SELECTOR_AUTOPLAY_IS_AUTOPLAY_VISIBLE);
  const firstPlay = useSelector(SELECTOR_PLAYBACK_FIRST_PLAY);
  const isStatsVisible = useSelector(SELECTOR_UI_IS_STATS_VISIBLE);
  const isUserActive = useSelector(SELECTOR_UI_IS_USER_ACTIVE);
  const isSettingsVisible = useSelector(SELECTOR_UI_SETTINGS_VISIBLE);
  const isSubtitleSettingsVisible = useSelector(SELECTOR_UI_SUBTITLE_SETTINGS_VISIBLE);
  const isSeeking = useSelector(SELECTOR_PLAYBACK_IS_SEEKING);

  const isActiveOverlayVisible = useMemo(() => {
    if (isAutoplayVisible) return false;
    if (!firstPlay) return false;
    if (isSeeking) return true;

    return isUserActive || isStatsVisible || isSettingsVisible || isSubtitleSettingsVisible;
  }, [
    firstPlay,
    isSeeking,
    isAutoplayVisible,
    isUserActive,
    isStatsVisible,
    isSettingsVisible,
    isSubtitleSettingsVisible,
  ]);

  return { isActiveOverlayVisible };
};

export default useActiveOverlay;
